import React from 'react';

//FIXME:/DELETE is the functionality in the room with us?
const RtwContext = React.createContext();

export default RtwContext;
